module.exports = __webpack_public_path__ + "static/media/post_2.e22d8511.jpeg";